import $ from 'jquery';
import WebLLCRESTApi from "../api/api";
import uuid from "../util/uuid";

export default {
  name: "ArticleData",
  data() {
    return {
      publishedUrl: "",
      createdAt: "",
      isInvalidURL: false,
    }
  },
  props: {
    clientId: String
  },
  methods: {
    async onAddArticle() {
      if(this.isInvalidURL == false) {
        var api = new WebLLCRESTApi("Client-Pages");
        
        var newArticleDetails = {
          url: this.publishedUrl,
          category: "article",
          linkType: "positive",
          hasLogin: false,
          createdAt: this.createdAt + "T00:00:00Z",
          clientId: this.clientId
        };
        
        var res = await api.addData(newArticleDetails);
        if(res.status < 400) {
          const json = await res.json();
          
          this.$emit('added', json.id);
          $('#modal-add-article-data').modal('toggle');
        }
        else {
          const json = await res.json();
          alert(JSON.stringify(json));
        }
      }
    }
  
  },
  
  watch: {
    publishedUrl(to) {
      if(to) {
        try {
          new URL(to);
          this.isInvalidURL = false;
        }
        catch(e) {
          this.isInvalidURL = true;
        }
      }
      else {
        this.isInvalidURL = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticleData.js